import { Paper, Typography, CircularProgress } from "@material-ui/core";
import { ArrowBackIos } from "@material-ui/icons";
import styled from "styled-components";

export const Container = styled(Paper)`
  max-width: 700px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  padding: 28px;

  fieldset {
    padding-top: 28px;
  }

  .MuiFormHelperText-root {
    color: red;
  }

  .customer-already-exists {
    color: #fff;

    margin: 10px;

    :hover {
      cursor: pointer;
    }

    a {
      color: #fff;
      padding-left: 10px;
    }
  }

  .react-tel-input {
    margin-bottom: 20px;
  }

  .react-tel-input .form-control {
    width: 100%;
  }

  .react-tel-input + .Mui-error {
    margin-top: -17px;
    margin-bottom: 20px;
  }

  fieldset + fieldset {
    margin-top: 20px;
  }

  .icon-button {
    text-align: center;
    margin-right: 8px;
    padding-left: 8px;
    padding-top: 4px;
    padding-bottom: 4px;

    :hover {
      border-radius: 50%;
      background-color: #d8d8d87d;
      cursor: pointer;
    }
  }
`;
export const Header = styled(Typography)``;

export const goBackButton = styled(ArrowBackIos)``;

export const NewTagContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  height: 30vh;
`;
export const NewTagTitle = styled.strong`
  font-size: 16px;
`;
export const NewTagInput = styled.input`
  width: 80%;
  height: 36px;
  border: 1px solid;
  border-radius: 3px;
  border-color: #d3d3d3;

  font-size: 15px;
  padding-left: 13px;

  &:focus {
    border-color: #3d9be9;
    outline: none;
  }
`;
export const NewTagButton = styled.button`
  width: 80%;
  height: 36px;
  border: 0;
  border-radius: 5px;
  background-color: #3d9be9;
  color: white;
  font-weight: 500;
  font-size: 16px;
`;
export const Loading = styled(CircularProgress).attrs({
  size: "24px",
})`
  color: white;
`;
